
import React from 'react';
import { Link } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-theme(spacing.16))] text-center px-4"> {/* Adjust min-h if header height changes */}
      <h1 className="text-6xl font-bold text-brand-teal mb-4">404</h1>
      <h2 className="text-3xl font-semibold text-dark-text-primary mb-2">Página Não Encontrada</h2>
      <p className="text-dark-text-secondary mb-8 max-w-md">
        Oops! A página que você está procurando não existe. Pode ter sido movida ou digitada incorretamente.
      </p>
      <Link
        to="/dashboard"
        className="font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-primary inline-flex items-center justify-center transition-colors duration-150 bg-brand-teal hover:bg-opacity-80 text-white focus:ring-brand-teal px-6 py-3 text-base"
      >
        Voltar para o Dashboard
      </Link>
    </div>
  );
};
